export function keyMapper(recordForRowAt) {
  return function (indexPath) {
    var record = recordForRowAt(indexPath); // 默认使用 record 的 id 当 key

    var id = record && record.id;
    var {
      section,
      row
    } = indexPath;
    return id || "".concat(section, "-").concat(row);
  };
}